import {Pipe} from '@angular/core';

@Pipe({
  name: 'shortGermanDate'
})
export class ShortGermanDatePipe {
  transform(value, args?) {
		if (value && value.length == 10 && value.charAt(2) === '.' && value.charAt(5) === '.')
			return value.substring(0, 6);
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/short-german-date.pipe.ts